import React from "react";
import Calender from "../../../InterstellrComponents/Calendar";
import FadeIn from "react-fade-in";

const MoodCaptureCalendar = () => {
  return (
    <>
      <FadeIn>
        <div className="container mx-auto">
          <div className="w-full md:w-2/3 mx-auto px-6 md:px-0">
            <h4 className="text-xl md:text-2xl font-semibold pt-12">
              Mood Capture Calendar
            </h4>
            <div className="row position-relative">
              <div className="mt-6">
                <Calender />
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </>
  );
};

export default MoodCaptureCalendar;
